<template>
  <div class="index-container">
    <img src="../assets/img/logo.png" alt="" class="logo-box" />
    <div class="login-cont">
      <header class="login-cont-title">研究生录取邮递地址管理平台</header>
      <section class="login-cont-body">
        <div class="login-cont-body-item">
          <span>用户名：</span>
          <i-input
            style="width: calc(100% - 80px)"
            v-model="obj.userName"
            placeholder="用户名"
          />
        </div>
        <div class="login-cont-body-item">
          <span>密 码：</span>
          <i-input
            class="value-box"
            type="password"
            v-model="obj.password"
            placeholder="密码"
          />
        </div>

        <div class="login-btn" @click="goLogin">登录</div>
        <div class="intro-container">
          <div>温馨提示:</div>
          <div class="intro-cont-box">
            建议使用<a :href="url1"
              ><img
                src="@/assets/img/google.png"
                class="google"
              />谷歌浏览器,</a
            >
            <a :href="url2"
              ><img
                src="../assets/img/ie.png"
                class="google"
              />360安全浏览器,</a
            >
            <span>点击即可下载,360安全浏览器请使用极速模式</span>
            <span @mouseenter="isShow = !isShow" @mouseleave="isShow = !isShow"
              >(如何使用?)</span
            >
            <img
              src="../assets/img/360.png"
              alt=""
              class="img-box"
              v-if="isShow"
            />
          </div>
        </div>
      </section>
    </div>
    <div class="support-box">杭州毕为科技有限公司技术支持</div>
  </div>
</template>

<script>
import AES from "@/AES.js";

export default {
  name: "login",
  data() {
    return {
      url1: "",
      url2: "",
      isShow: false,
      obj: {
        password: "",
        userName: "",
      },
    };
  },
  methods: {
    getBrowerUrl() {
      this.$axios.get("/api/basicData/queryBrowser").then((res) => {
        let data = res.data.data;
        data.forEach((el) => {
          let url = el.browserUrl.replace(
            "http://192.168.31.142:8888",
            "/api1"
          );
          if (el.browserName == "谷歌浏览器") {
            this.url1 = url;
          } else {
            this.url2 = url;
          }
        });
      });
    },
    goLogin() {
      if (!this.obj.userName || !this.obj.password) {
        return this.$Message.warning("请把账号及密码填写完整");
      }
      let parameter = AES.generatekey(16);
      let password = AES.encrypt(this.obj.password, parameter);
      let userName = AES.encrypt(this.obj.userName, parameter);
      let form = {
        parameter,
        password,
        userName,
      };
      this.$axios.post("/api/login", form).then((res) => {
        console.log(res);
        let data = res.data.data;
        if (data.userType == 2) {
          this.$router.push("/stuInfo");
        } else {
          this.$router.push("/list");
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.index-container {
  width: 100%;
  height: 100%;
  background: url("../assets/img/indexBg.png") no-repeat center;
  background-size: cover;
  .logo-box {
    width: 400px;
    margin: 50px;
  }
  .login-cont {
    width: 450px;
    height: 450px;
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    margin: auto;
    background: #fff;
    .login-cont-title {
      width: 100%;
      height: 70px;
      line-height: 70px;
      text-align: center;
      font-size: 28px;
      font-weight: bold;
      border-bottom: 1px dashed #ccc;
      color: $blue;
    }
    .login-cont-body {
      width: 100%;
      padding: 50px 30px;
      box-sizing: border-box;
      .login-cont-body-item {
        width: 100%;
        display: flex;
        align-items: center;
        margin-bottom: 20px;
        span {
          width: 80px;
          font-size: 16px;
        }
        .value-box {
          font-size: 16px;
          height: 34px;
          width: calc(100% - 80px);
        }
      }
      .login-btn {
        margin-top: 50px;
        width: 100%;
        height: 35px;
        background: $blue;
        line-height: 35px;
        text-align: center;
        color: #fff;
        border-radius: 5px;
      }
      .intro-container {
        margin-top: 30px;
        color: $red;
        font-size: 14px;
      }
      .intro-cont-box {
        position: relative;
        width: 100%;
        color: $red;
        display: flex;
        align-items: center;
        // justify-content: center;
        flex-wrap: wrap;
        padding-left: 20px;
        img {
          width: 20px;
          height: 20px;
        }
        a {
          color: $red;
          display: flex;
          align-items: center;
        }
        .img-box {
          position: absolute;
          bottom: 10px;
          right: -300px;
          width: 300px;
          height: 150px;
        }
      }
    }
  }
  .support-box {
    width: 100%;
    color: #fff;
    text-align: center;
    position: fixed;
    bottom: 50px;
    left: 0;
  }
}
</style>>
